import React from 'react'
import DOMPurify from 'isomorphic-dompurify'

interface SafeHTMLProps {
  html: string
  className?: string
  as?: 'div' | 'span' | 'p' | 'code'
}

export default function SafeHTML({ html, className, as = 'span' }: SafeHTMLProps) {
  const sanitizedHTML = DOMPurify.sanitize(html)
  const Component = as

  return <Component className={className} dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
}
